export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
export const monthsShort = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export function getTodayDate() {
    const today = new Date();
    const date = today.getDate();
    const month = today.getMonth() + 1; // January is 0!
    const dd = date < 10 ? `0${date}` : date;
    const mm = month < 10 ? `0${month}` : month;
    const yyyy = today.getFullYear();

    return `${yyyy}-${mm}-${dd}`;
}
